<template>
  <div class="ba-pane-control">
    <div
      class="background"
      :class="{ disabled: reportShowing }"
    ></div>

    <div class="feature zoom-control">
      <ba-slider
        :min="25"
        :max="175"
        :default="100"
        :buttonStep="25"
        :value="paneScale"
        :vertical="true"
        :minimal="true"
        @change="$emit('onPaneScaleChange', $event)"
      >
        <i class="tooltip">
          <span class="tooltip-text" v-html="$t('journey.control.zoom')"></span>
        </i>
      </ba-slider>
      <ba-button
        :icon="'icon--fit'"
        :iconActive="'icon--fit white'"
        @click="$emit('onPaneScaleFit')"
      >
        <i class="tooltip">
          <span class="tooltip-text" v-html="$t('journey.control.fitToPage')"></span>
        </i>
      </ba-button>
      <ba-button
        :active="!thumbnailHidden"
        :icon="'icon--image-off'"
        :iconActive="'icon--image-off white'"
        @click="$emit('toggleThumbnail')"
      >
        <i class="tooltip">
          <span class="tooltip-text">{{ thumbnailHidden ? $t('journey.control.showThumbnails') : $t('journey.control.hideThumbnails') }}</span>
        </i>
      </ba-button>
      <ba-button
        :icon="'icon--list-expand'"
        :iconActive="'icon--list-expand white'"
        @click="$emit('toggleNodesExpanded')"
      >
        <i class="tooltip">
          <span class="tooltip-text">{{ nodesExpanded ? $t('journey.control.collapseNodes') : $t('journey.control.expandNodes') }}</span>
        </i>
      </ba-button>
      <ba-button
        v-if="!subdomainSelected"
        :active="sitemapMode === 'firstPath'"
        :icon="'icon--sitemap-ungroup'"
        :iconActive="'icon--sitemap-ungroup white'"
        @click="toggleSitemapMode"
      >
        <i class="tooltip">
          <span class="tooltip-text">{{ sitemapMode === 'subdomain' ? $t('journey.control.ungroupSubdomains') : $t('journey.control.groupSubdomains') }}</span>
        </i>
      </ba-button>
    </div>
  </div>
</template>

<script>
import BaButton from '@/components/ui/ba/Button'
import BaSlider from '@/components/ui/ba/Slider'

export default {
  name: 'BaSitemapPaneControl',
  components: {
    BaButton,
    BaSlider
  },
  props: {
    paneScale: {
      type: Number,
      required: true
    },
    thumbnailHidden: {
      type: Boolean,
      default: false
    },
    nodesExpanded: {
      type: Boolean,
      default: false
    },
    sitemapMode: {
      type: String,
      default: 'subdomain'
    },
    subdomainSelected: {
      type: Boolean,
      default: false
    },
    reportShowing: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleSitemapMode () {
      this.$emit('changeSitemapMode', this.sitemapMode === 'subdomain' ? 'firstPath' : 'subdomain')
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-pane-control {
  position: relative;
  height: 100%;
  padding: 2px 10px 10px;
  box-sizing: border-box;
  text-align: center;

  .background {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(244, 244, 241, 0.7);
    backdrop-filter: blur(15px);

    &.disabled {
      background-color: rgba(219, 219, 216, 0.7);
    }
  }

  .feature {
    position: relative;
    z-index: 2;
    display: inline-block;
    vertical-align: middle;
    margin: 5px 0;

    .tooltip {
      position: absolute;
      top: 50%;
      left: 38px;
      padding: 30px 20px 30px 10px;
      transform: translate3d(-40px, -50%, 0);
      opacity: 0;
      pointer-events: none;
      transition: transform 0.2s ease, opacity 0.2s ease;

      &::after {
        content: '';
        background-color: #fff;
        position: absolute;
        z-index: 2;
        transform: rotate(-135deg);
        width: 8px;
        height: 8px;
        box-shadow: 1px -1px 0 0 rgba(0, 0, 0, 0.16);
        top: calc(50% - 4.5px);
        left: 6px;
      }

      .tooltip-text {
        border-radius: 6px;
        white-space: nowrap;
        box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        padding: 8px 10px 9px;
        color: #444444 !important;
        font-size: 13px;
        line-height: 1;
      }
    }

    .ba-slider {
      margin: 3px 0 2px 0;
    }

    .ba-button {
      margin: 3px 0 2px 0;

      & /deep/ {
        .text {
          margin-left: 0;
        }
      }
    }

    .ba-slider:hover,
    .ba-button button:not(.keep-active):hover {
      .tooltip {
        transform: translate3d(0, -50%, 0);
        opacity: 1;
      }
    }
  }
}
</style>
